import axios from 'axios';

const apiIp = axios.create({
    baseURL: 'https://pro.ip-api.com/',
});

export function getIP() {
    return apiIp.request({
        url: '/json/?fields=status,message,countryCode&key=MoP2OvRc1pft4uo',
        method: 'GET',
    });
}
